import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import SettingsIcon from '@mui/icons-material/Settings';
import FrontHydraulicsIcon from '../icons/FrontHydraulicsIcon';
import RearHydraulicsIcon from '../icons/RearHydraulicsIcon';
import { MenuItem, Select, TextField } from '@mui/material';

const CenteredContainer = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  background: theme.palette.background.paper,
  width: '100%',
  textAlign: 'center',
  marginTop: theme.spacing(2),
}));

const MenuItemBox = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  border: '1px solid white',
  margin: '2px 0', // 2px margin between rows
  width: '100%',
  cursor: 'pointer',
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
}));

const HydraulicsComponent = ({ onBackToMenu, handleItemClick }) => {
  const [selectedHydraulic, setSelectedHydraulic] = useState(null);
  const [mode, setMode] = useState('');
  const [userText, setUserText] = useState('');

  const hydraulicsOptions = [
    { icon: <FrontHydraulicsIcon />, text: 'Front Hydraulics' },
    { icon: <RearHydraulicsIcon />, text: 'Rear Hydraulics 1' },
    { icon: <RearHydraulicsIcon />, text: 'Rear Hydraulics 2' },
  ];

  const handleHydraulicSelect = (option) => {
    setSelectedHydraulic(option);
    handleItemClick(option);
  };

  const handleSettingsClick = (option) => {
    setSelectedHydraulic(`settings-${option}`);
  };

  const renderPrimaryMenu = () => (
    <CenteredContainer elevation={4}>
      <Typography variant="h6">Hydraulics Menu</Typography>
      <Grid container spacing={0} justifyContent="center" alignItems="center"> {/* No spacing between items */}
        {hydraulicsOptions.map((option, index) => (
          <Grid item xs={12} key={index}>
            <MenuItemBox>
              <div
                style={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}
                onClick={() => handleHydraulicSelect(option.text)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleHydraulicSelect(option.text);
                  }
                }}
              >
                <IconButton>{option.icon}</IconButton>
                <Typography variant="body1" style={{ marginLeft: '10px' }}>
                  {option.text}
                </Typography>
              </div>
              <Tooltip title="Settings">
                <IconButton onClick={() => handleSettingsClick(option.text)}>
                  <SettingsIcon />
                </IconButton>
              </Tooltip>
            </MenuItemBox>
          </Grid>
        ))}
      </Grid>
      <Button variant="contained" color="primary" onClick={onBackToMenu} style={{ marginTop: 20 }}>
        Back to Main Menu
      </Button>
    </CenteredContainer>
  );

  const renderSettingsMenu = () => (
    <CenteredContainer elevation={4}>
      <Typography variant="h6">Hydraulics Settings</Typography>
      <Select
        value={mode}
        onChange={(e) => setMode(e.target.value)}
        displayEmpty
        fullWidth
        style={{ marginTop: 20 }}
      >
        <MenuItem value="" disabled>Select Mode</MenuItem>
        <MenuItem value="frontLinkage">Front Linkage</MenuItem>
        <MenuItem value="rearLinkage">Rear Linkage</MenuItem>
        <MenuItem value="manual">Manual</MenuItem>
        <MenuItem value="continuous">Continuous</MenuItem>
      </Select>
      <TextField
        label="User Defined Text"
        value={userText}
        onChange={(e) => setUserText(e.target.value)}
        fullWidth
        style={{ marginTop: 20 }}
      />
      <Button variant="contained" color="primary" onClick={() => setSelectedHydraulic(null)} style={{ marginTop: 20 }}>
        Return to Hydraulics Menu
      </Button>
    </CenteredContainer>
  );

  return (
    <>
      {selectedHydraulic && selectedHydraulic.startsWith('settings') ? renderSettingsMenu() : renderPrimaryMenu()}
    </>
  );
};

export default HydraulicsComponent;
